import { Button, Toggle } from 'components';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.div`
  display: grid;
  ${from.laptop`
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
  `}
`;

export const Title = styled.h2`
  margin: 0 0 1rem;
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  color: ${({ theme }) => theme.colors.primary};
  ${from.laptop`
    grid-column: span 2;
  `}
`;

export const NotificationTitle = styled(Title)`
  margin: 0;
`;

export const EmailNotificationsContainer = styled.div`
  margin-top: 2.125rem;
  padding-top: 2.125rem;
  border-top: 1px solid ${({ theme }) => theme.colors.grey200};
  ${from.laptop`
    grid-column: 1;
  `}
`;

export const NotificationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const CloseAccountContainter = styled.div`
  margin-top: 2.125rem;
  padding-top: 2.125rem;
  border-top: 1px solid ${({ theme }) => theme.colors.grey200};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  ${from.laptop`
    grid-column: 1;
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
`;

export const Paragraph = styled.p`
  margin: 0;
  max-width: 21.25rem;
  line-height: 1.5;
`;

export const NotificationDescription = styled.p`
  margin: 0;
  line-height: 1.5;
`;

export const StyledToggle = styled(Toggle)`
  width: 2.321rem;
  height: 1.25rem;
  border-radius: 0.625rem;

  &::after {
    width: 0.982rem;
    height: 0.982rem;
    margin-top: 0.08rem;
    margin-left: 0.134rem;
    margin-right: 0.134rem;
    margin-bottom: 1.134rem;
  }

  ${from.laptop`
    &::after {
    margin-top: 0.064rem;
  }
  `}

  &:checked::after {
    margin-left: 1.134rem;
  }
`;

export const CloseButton = styled(Button)`
  flex-shrink: 0;
`;
